<template>
  <div class="user-tools">
    <div class="tools-header">
      <div class="title">常用功能</div>
    </div>
    <div class="tools-main">
      <div class="tools-item" v-for="(item,idx) in commonList01" :key="idx">
        <div class="icon" :style="item.style">
          <img :src="item.icon" :alt="item.name" @click="onNavigate(item)" width="24" height="24" v-if="item.url != undefined">
          <img :src="item.icon" :alt="item.name" v-clipboard:copy="copyTxt" v-clipboard:success="onCopy" style="width: 100%;height: 100%;" v-if="item.url == undefined">
        </div>
        <span class="name">{{item.name}}</span>
      </div>
    </div>
    <div class="tools-main">
      <div class="tools-item" v-for="(item,idx) in commonList02" :key="idx" @click="onNavigate(item)">
        <div class="icon" :style="item.style">
          <img :src="item.icon" :alt="item.name" v-if="idx < 4" width="24" height="24">
        </div>
        <span class="name">{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { isAudit } from '@/api/mine/cnter.js'
  export default {
    data() {
      return {
        copyTxt : '',
        commonList01: [
          {
            icon: require("@/assets/tool01.png"),
            name: '我的求购',
            style: 'background:linear-gradient(201deg,rgba(254,154,1,1) 0%,rgba(248,58,80,1) 100%);',
            checked: false,
            url:'/mine/buy/myBuy'
          },
          {
            icon: require("@/assets/tool02.png"),
            name: '我的发票',
            style: 'background:linear-gradient(201deg,rgba(255,198,1,1) 0%,rgba(254,151,1,1) 100%);',
            checked: false,
            url:'/invoice'
          },
          {
            icon: require("@/assets/tool03.png"),
            name: '收货地址',
            style: 'background:linear-gradient(201deg,rgba(0,211,122,1) 0%,rgba(105,210,0,0.76) 100%);',
            checked: false,
            url:'/address'
          },
          {
            icon: require("@/assets/tool04.png"),
            name: '我的收藏',
            style: 'background:linear-gradient(201deg,rgba(105,190,255,1) 0%,rgba(114,58,248,1) 100%);',
            checked: false,
            url:'/collect'
          }
          // {
          //   icon: require("@/assets/share.png"),
          //   name: '分享好友',
          //   style: '',
          //   url:undefined
          // }
        ],
        commonList02: [
          {
            icon: require("@/assets/tool05.png"),
            name: '我的足迹',
            style: 'background:linear-gradient(201deg,rgba(105,170,255,1) 0%,rgba(58,248,229,1) 100%);',
            checked: false,
            url:'/track'
          },
          {
            icon: require("@/assets/tool06.png"),
            name: '免费入驻',
            style: 'background:linear-gradient(201deg,rgba(211,105,255,1) 0%,rgba(166,58,248,1) 100%);',
            checked: true,
            url:'/enterApply'
          },
          {
            icon: require("@/assets/tool07.png"),
            name: '会员权益',
            style: 'background:linear-gradient(201deg,rgba(255,220,105,1) 0%,rgba(248,172,58,1) 100%);',
            checked: false,
            url:'/mine/vip/interests'
          },
          {
            icon: require("@/assets/tool08.png"),
            name: '联系客服',
            style: 'background:linear-gradient(201deg,rgba(255,105,105,1) 0%,rgba(248,110,58,1) 100%);',
            checked: false,
            url:'/service'
          }
        ]
      }
    },
    created() {
      var user = localStorage.getItem('userInfo')
      if (user){
        user = JSON.parse(user)
        this.copyTxt = 'http://ckaicai.com/?pid=' + user.id
      }
    },
    methods:{
      getShopApply(){
        var user = localStorage.getItem('userInfo')
        user = JSON.parse(user)
        isAudit({uid: user.id}).then(res=>{
          if (res.success){
            if (res.data){
              localStorage.setItem('storeInfo',JSON.stringify(res.data.userInfo))
              if (res.data.userInfo.storeId != null) {
                localStorage.setItem('storeId',res.data.userInfo.storeId)
              }
              this.$router.push({
                path:'/business/'
              })
            }else{
              this.$router.push({
                path:'/business/supplierLogin'
              })
            }
          }else{
            this.$router.push({
              path: '/enterApply'
            })
          }
        })
      },
      onCopy () {
        this.$toast.success('复制成功,请发给你的好友')
      },
      // 跳转
      onNavigate(item) {
        if (item.url) {
          if (item.checked){
            this.getShopApply()
          } else{
            this.$router.push({
              path: item.url
            })
          }
        }
      },
    }
  }
</script>

<style lang="less" scoped>
.user-tools {
  height:296px;
  background:rgba(255,255,255,1);
  margin-top: 2px;
  padding: 15px 12px;
  .tools-header{
    height:22px;
    font-size:16px;
    font-weight:bold;
    line-height:22px;
    color:rgba(51,51,51,1);
    border-left: 4px solid #FE003B;
    padding-left: 8px;
  }
  .tools-main{
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .tools-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 32px;
      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 46px;
        height: 46px;
        border-radius: 50%;
      }
      .name {
        height: 20px;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        color: rgba(51, 51, 51, 1);
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mine/modules/Tools.vue